export default __webpack_public_path__ + "static/media/gallery_02.08610637.jpg";